export class ModelFilter {
    public ModelGroupID?: number;
    public SectionID?: number;
    public IncludeInactive?: boolean;
}

export default ModelFilter;